<template>
  <PageTemplate>
    <div class="d-flex justify-content-between">
      <h6 class="element-header">
        {{ $t('sent_email.title') }}
      </h6>
    </div>

    <div class="element-box">
      <h5 class="form-header mb-4">
        {{ $t('sent_email.list') }}
      </h5>

      <Search
          :filters="filters"
          :loading="isSearching"
          @search="getEmails"/>

      <PerPage :values="[10, 25, 50, 100]" @update:perPage="getEmails"/>

      <div class="table-responsive overflow-auto pt-4">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>ID</th>
            <th>Hergestellt in</th>
            <th style="min-width: 200px;">Status</th>
            <th>Typ</th>
            <th>Senden an</th>
            <th>Senden Sie an</th>
            <th style="min-width: 360px!important; padding-right: 95px!important; text-align: right">
              <a href="#">{{ $t('general.actions') }}</a>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(email) in emails.data" :key="email.id">
            <td>{{ email?.id }}</td>
            <td>{{ email?.createdAt }}</td>
            <td>
               <span v-if="email.status === 'sent'">
                   <span class="status-pill green p-2 mr-2"
                         data-toggle="tooltip">
                   </span>
               </span>
              <span v-else>
                 <span class="status-pill red p-2 mr-2"
                       data-toggle="tooltip">
                   </span>
              </span>
              {{ email?.statusTranslated }}
            </td>
            <td>{{ email?.typeTranslated }}</td>
            <td>{{ email?.receiverEmail }}</td>
            <td>{{ email?.sendAt }}</td>
            <td class="d-flex justify-content-end">
              <div class="mr-2" v-if="email.status === 'error'">
                <button class="btn btn-outline-primary"
                        @click="handleResendEmailModal(email.id)">
                  Nochmal senden
                </button>
              </div>
              <button class="btn btn-primary"
                      @click="router.push({name: 'sendEmailDetails', params: {id: email?.id} })">
                Einzelheiten
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination
          v-if="emails?.pagination?.total_pages > 1"
          :totalPages="emails?.pagination?.total_pages"
          :currentPage="emails?.pagination?.current_page"
          :totalItems="emails?.pagination?.total_items"
          :perPage="emails?.pagination?.items_per_page"
          @pagechanged="getEmails"/>
    </div>
  </PageTemplate>


  <ModalConfirm
      v-model="showSendEmailAgainModal"
      confirmationQuestion="Möchten Sie erneut eine E-Mail senden?"
      header="E-Mail erneut senden"
      :onConfirm="resendEmail"/>
</template>


<script setup>

import sendEmailService from '@/api/SendEmail';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import Search from '@/views/App/SendEmail/Search.vue';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }                   = useI18n();
const emails                  = ref([]);
const filters                 = ref({
  email: '',
  type: '',
  status: '',
});
const emailId                 = ref(null);
const isSearching             = ref(false);
const showSendEmailAgainModal = ref(false);

async function getEmails(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  const perPageRes = emails.value?.pagination?.items_per_page;

  try {
    const { data } = await sendEmailService.getEmails({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    emails.value      = data;
    isSearching.value = false;
  } catch (error) {
    isSearching.value = false;
    await ErrorToast(error);
  }
}

function handleResendEmailModal(id) {
  emailId.value                 = null;
  emailId.value                 = id;
  showSendEmailAgainModal.value = true;
}

async function resendEmail() {
  try {
    await sendEmailService.resendEmail(+emailId.value);

    emailId.value                 = null;
    showSendEmailAgainModal.value = false;
    await getEmails()
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    emailId.value                 = null;
    showSendEmailAgainModal.value = false;
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getEmails();
});

</script>

<style scoped>

</style>